import styled from 'styled-components';
import { IonContent, IonMenu, IonMenuToggle } from '@ionic/react';
import { AllieDrawerProps } from './Drawer.types';
import { AllieText } from '../Text';
import { AllieChevronBackOutline, AllieCloseOutlineIcon } from '../../styling/icons';
import { AllieIconButton } from '../Buttons/IconButton';

export const StyledDrawer: any = styled(IonMenu)<AllieDrawerProps>`
  --width: ${(props: AllieDrawerProps) => props.width && props.width};
`;

export const StyledDrawerContent: any = styled(IonContent)`
  --padding-start: 24px;
  --padding-end: 24px;
  --padding-top: 0;
  --padding-bottom: 16px;
`;

export const StyledCloseIcon = styled(AllieCloseOutlineIcon)`
  stroke: var(--allie-color-neutral-70);
  color: var(--allie-color-neutral-70);
  fill: var(--allie-color-neutral-70);

  font-size: 32px;
`;

export const StyledChevronBackOutline = styled(AllieChevronBackOutline)`
  stroke: var(--allie-color-neutral-70);
  color: var(--allie-color-neutral-70);
  fill: var(--allie-color-neutral-70);
  font-size: 20px;
`;

export const StyledIconButton = styled(AllieIconButton)`
  background-color: white;
  margin: 0;
  color: var(--allie-color-neutral-30);
  border: 1px solid var(--allie-color-neutral-30);
  border-radius: 10px;

  && {
    --border-color: var(--allie-color-neutral-30);
  }
`;

export const StyledIconContainer = styled.div`
  display: flex;
  border: 1px solid var(--allie-color-neutral-30);
  border-radius: 10px;
  padding: 5px;
  cursor: pointer;
`;

export const ToolbarHeader = styled.div<{ isMobile: boolean }>`
  display: flex;
  justify-content: ${({ isMobile }) => !isMobile && 'space-between'};
  align-items: center;
  gap: ${({ isMobile }) => isMobile && 'var(--allie-spacing-xl)'};

  & ion-button:hover {
    --background: transparent;
  }
`;
